import { EnumFuncionalidade } from '@/constants/EnumFuncionalidade'

function mapListFromIntegracao (contratosLogin, lista, beneficiariosLogin) {
  let novaLista = []
  contratosLogin.forEach((contrato) => {
    let dadosLista = lista.find(
      (itemLista) => contrato.numeroContrato.toString() === itemLista.numeroContrato.toString()
    )

    const newItem = {
      plano: contrato.descricaoContrato,
      contrato: contrato.numeroContrato,
      data: dadosLista ? formatBeneficiarios(dadosLista.beneficiarios, beneficiariosLogin, contrato) : []
    }

    novaLista.push(newItem)
  })

  return novaLista
}

function mapListFromLogin (contratosLogin, beneficiariosLogin, idFunc) {
  let novaLista = []
  contratosLogin.forEach((contrato) => {
    const beneficiarios = beneficiariosLogin.filter((beneficiario) => {
      const permissao = beneficiario.acessoFuncionalidade ? possuiPermissao(beneficiario, idFunc) : true
      if (permissao) {
        const isPermissaoFunc = permissaoFuncLogin(beneficiario, idFunc)
        return (
          beneficiario.dadosDoContrato.numeroContrato === contrato.numeroContrato && isPermissaoFunc
        )
      }
    })

    const newItem = {
      plano: contrato.descricaoContrato,
      contrato: contrato.numeroContrato,
      data: formatBeneficiarios(beneficiarios, beneficiariosLogin, contrato)
    }

    novaLista.push(newItem)
  })

  return novaLista
}

function permissaoFuncLogin (beneficiario, idFunc) {
  if (idFunc === EnumFuncionalidade.CARTAO) {
    return beneficiario.cartao.apresentaCartaoVirtual
  }
  return true
}

function possuiPermissao (beneficiario, idFunc) {
  if (beneficiario.acessoFuncionalidade.length === 0) {
    return true
  } else {
    return beneficiario.acessoFuncionalidade.indexOf(idFunc) !== -1
  }
}

function mapListaByContrato (lista, contratosLogin, beneficiariosLogin, idFunc, visualizaContratosVazios = false) {
  let novaLista = []
  if (Array.isArray(lista) && lista.length > 0) {
    novaLista = mapListFromIntegracao(contratosLogin, lista, beneficiariosLogin, novaLista)
  } else {
    novaLista = mapListFromLogin(contratosLogin, beneficiariosLogin, idFunc, novaLista)
  }

  if (!visualizaContratosVazios) {
    novaLista = removeContratosVazios(novaLista)
  }

  return novaLista
}

function mapListaByContratoOnly (contratosLogin, beneficiariosIntegracao) {
  let contratoList = [...contratosLogin]

  if (beneficiariosIntegracao) {
    contratoList = contratoList.filter(contrato => {
      return beneficiariosIntegracao.find(({ numeroContrato }) => contrato.numeroContrato.toString() === numeroContrato.toString())
    })
  }

  return contratoList.map((contrato) => {
    return {
      ...contrato,
      abreviacao: formatAbreviatura(contrato.descricaoContrato),
      cor: getCorAleatoria()
    }
  })
}

function removeContratosVazios (listaContratos) {
  return listaContratos.filter(contrato => Array.isArray(contrato.data) && contrato.data.length > 0)
}

const formatBeneficiarios = (lista, beneficiariosLogin, contrato) => {
  let result = []
  if (Array.isArray(lista) && lista.length > 0) {
    lista.forEach((item) => {
      const beneficiario = beneficiariosLogin.find(
        (beneficiarioLogin) => beneficiarioLogin.chaveUnica.toString() === item.chaveUnica.toString() &&
          beneficiarioLogin.dadosDoContrato.numeroContrato.toString() === contrato.numeroContrato.toString()
      )
      if (beneficiario) {
        result.push({
          nome: beneficiario.dadosPessoais.nome,
          abreviacao: formatAbreviatura(beneficiario.dadosPessoais.nome),
          matricula: beneficiario.dadosDoPlano.matricula,
          chaveUnica: beneficiario.chaveUnica,
          tipoBeneficiario: beneficiario.dadosDoPlano.tipoUsuario.descricao,
          cor: getCorAleatoria(),
          foto: '',
          numeroContrato: contrato.numeroContrato,
          beneficiarioDados: beneficiario,
          contrato
        })
      }
    })
  }
  return result
}

const formatAbreviatura = (nome) => {
  let abreviatura = ''
  if (nome) {
    let arrayNomes = nome.split(' ')
    let firtName = arrayNomes[0]
    let lastName = ''
    if (arrayNomes.length > 1) {
      lastName = arrayNomes.pop()
    }
    abreviatura = (firtName[0] || '').toUpperCase() + (lastName[0] || '').toUpperCase()
  }
  return abreviatura
}

const getCorAleatoria = () => {
  const cores = [
    '#8CE38C',
    '#FFDB7B',
    '#FCC99E',
    '#FC9E9E',
    '#AD94E5',
    '#7BC2FF'
  ]
  const min = Math.ceil(0)
  const max = Math.floor(5)
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min
  return cores[randomNum]
}

export {
  mapListaByContrato,
  formatAbreviatura,
  getCorAleatoria,
  formatBeneficiarios,
  mapListaByContratoOnly
}
